<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head">Product QR Rewards
        <div>
            <button class="me-2" mat-stroked-button color="primary" (click)="back()">
                <mat-icon>arrow_back</mat-icon>Back
            </button>
            <button mat-raised-button color="primary" (click)="addBatch()">
                <mat-icon>add</mat-icon>Generate Batch
            </button>
        </div>
    </div>
</div>

<div class="mat-elevation-z8 qr-page">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search">
    </mat-form-field>

    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Sr.No</th>
                <td mat-cell *matCellDef="let element">{{element.srNo}}</td>
            </ng-container>

            <ng-container matColumnDef="batch_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Batch Name</th>
                <td mat-cell *matCellDef="let element">{{element.batch_name}}</td>
            </ng-container>
            
            <ng-container matColumnDef="product_title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
                <td mat-cell *matCellDef="let element">{{element.product_title}}</td>
            </ng-container>

            <ng-container matColumnDef="total_qr_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>QRs</th>
                <td mat-cell *matCellDef="let element">{{element.total_qr_count}}</td>
            </ng-container>

            <ng-container matColumnDef="points_per_scan">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Points</th>
                <td mat-cell *matCellDef="let element">{{element.points_per_scan}}</td>
            </ng-container>

            <ng-container matColumnDef="assigned_user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned User</th>
                <td mat-cell *matCellDef="let element">{{element.assigned_user}}</td>
            </ng-container>

            <ng-container matColumnDef="expiry_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry</th>
                <td mat-cell *matCellDef="let element">{{element.expiry_date | date:'dd/MM/yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="claimed_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Claimed</th>
                <td mat-cell *matCellDef="let element">{{element.claimed_count}} / {{element.total_qr_count}}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-pill" [class.active]="element.status === 'active'">{{element.status}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element" class="actions">
                    <button mat-icon-button color="primary" matTooltip="View QR codes" (click)="viewCodes(element)">
                        <mat-icon>qr_code_2</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" matTooltip="View Scan Analytics"
                        (click)="viewScanAnalytics(element)">
                        <mat-icon>analytics</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" matTooltip="Print QR Stickers"
                        (click)="printStickers(element)">
                        <mat-icon>print</mat-icon>
                    </button>
                    <!-- <button mat-icon-button color="accent" matTooltip="View Claim Rewards" (click)="viewClaimRewards(element)">
                        <mat-icon>redeem</mat-icon>
                    </button> -->
                    <!-- <button mat-icon-button matTooltip="Export CSV" (click)="exportCodes(element)">
                        <mat-icon>download</mat-icon>
                    </button>
                    <button *ngIf="element.status !== 'active'" mat-icon-button color="primary" matTooltip="Activate"
                        (click)="updateStatus(element, 'active')">
                        <mat-icon>play_circle</mat-icon>
                    </button>
                    <button *ngIf="element.status === 'active'" mat-icon-button color="warn" matTooltip="Deactivate"
                        (click)="updateStatus(element, 'inactive')">
                        <mat-icon>pause_circle</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" matTooltip="Expire" (click)="updateStatus(element, 'expired')">
                        <mat-icon>event_busy</mat-icon>
                    </button> -->
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>